import React, { useState, useEffect, useRef } from "react";
import { WHO_WE_SERVE } from "../data";

function WhoWeServe() {
  const [scrollPos, setScrollPos] = useState(0);
  const speed = 0.007; // Smooth automatic speed
  const isHovered = useRef(false);

  // Triple cards for a seamless loop
  const tripleItems = [...WHO_WE_SERVE, ...WHO_WE_SERVE, ...WHO_WE_SERVE];
  const itemCount = WHO_WE_SERVE.length;

  useEffect(() => {
    let animationFrame;
    const animate = () => {
      if (!isHovered.current) {
        setScrollPos(prev => {
          let next = prev + speed;
          if (next >= itemCount) next = 0;
          return next;
        });
      }
      animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [itemCount]);

  return (
    <section className="who-we-serve" id="who-we-serve">
      <h2>Who We Serve</h2>
      <div
        className="serve-carousel-container"
        onMouseEnter={() => { isHovered.current = true; }}
        onMouseLeave={() => { isHovered.current = false; }}
      >
        <div className="serve-slider-wrapper">
          <div
            className="serve-slider-track"
            style={{
              // Step = width + gap = (32vw - 7.5px) + 10px = 32vw + 2.5px
              transform: `translateX(calc(-${scrollPos} * (32vw + 2.5px)))`,
              transition: "none"
            }}
          >
            {tripleItems.map((item, index) => {
              const offset = index - scrollPos;

              let rotateY = 0;
              let originX = 'center';
              let opacity = 1;

              // 32vw width layout: folding at screen edges
              if (offset >= -1 && offset <= 0) {
                // Folding out on the left
                rotateY = 25 * (1 + offset);
                originX = 'right';
              } else if (offset > 0 && offset < 2) {
                // Flat in the middle
                rotateY = 0;
                originX = 'center';
              } else if (offset >= 2 && offset <= 3) {
                // Folding in on the right
                rotateY = -25 * (1 - (offset - 2));
                originX = 'left';
              } else if (offset < -1.5 || offset > 4) {
                // Hide cards outside the view with a safety margin
                opacity = 0;
              }

              return (
                <div
                  className="serve-card-3d"
                  key={index}
                  style={{
                    backgroundImage: `url(${item.img})`,
                    transformOrigin: `${originX} center`,
                    transform: `rotateY(${rotateY}deg)`,
                    opacity: opacity,
                    visibility: opacity > 0 ? 'visible' : 'hidden',
                    width: 'calc(32vw - 7.5px)',
                    backgroundColor: '#c5cff5'
                  }}
                >
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhoWeServe;
